import { render } from "./Header.vue?vue&type=template&id=666f1375"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"
script.render = render

export default script